import React, { useEffect, useState } from "react";
import { getCustomerRate, calculateCost } from "../lib/rates";
import { UNITS } from "../lib/warehouses";

export default function ShippingRateCard({ email, warehouse }) {
  const [rates,   setRates]   = useState({});
  const [weight,  setWeight]  = useState("");
  const [selUnit, setSelUnit] = useState("7000");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!email || !warehouse) return;
    Promise.all(
      Object.keys(UNITS).map(unit =>
        getCustomerRate(email, warehouse, unit).then(r => ({ unit, r }))
      )
    ).then(results => {
      const map = {};
      results.forEach(({ unit, r }) => { if (r) map[unit] = r; });
      setRates(map);
      setLoading(false);
    });
  }, [email, warehouse]);

  if (loading) return null;
  if (Object.keys(rates).length === 0) return (
    <div style={{ background: "var(--bg-soft)", border: "0.5px solid var(--border)", borderRadius: "var(--radius-lg)", padding: "1rem 1.25rem", marginBottom: "1.25rem" }}>
      <div style={{ fontSize: 13, color: "var(--text-muted)" }}>No shipping rate set for this warehouse yet. Contact LebMarket.</div>
    </div>
  );

  const activeRate = rates[selUnit];
  const cost = weight && activeRate ? calculateCost(parseFloat(weight), activeRate.ratePerKg) : null;

  return (
    <div style={{ background: "var(--bg)", border: "0.5px solid var(--border)", borderRadius: "var(--radius-lg)", padding: "1rem 1.25rem", marginBottom: "1.25rem", boxShadow: "var(--shadow-sm)" }}>
      <div style={{ fontSize: 12, color: "var(--text-muted)", fontWeight: 600, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: 10 }}>Your shipping rates</div>

      {/* Unit tabs */}
      <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        {Object.entries(UNITS).map(([k, v]) => (
          <button key={k} onClick={() => setSelUnit(k)} style={{
            padding: "6px 14px", borderRadius: 20, border: "0.5px solid var(--border-md)",
            background: selUnit === k ? "var(--green)" : "transparent",
            color: selUnit === k ? "#fff" : "var(--text-muted)",
            cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "inherit",
          }}>
            {v.label}
          </button>
        ))}
      </div>

      {activeRate ? (
        <>
          <div style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 4 }}>{UNITS[selUnit]?.desc}</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: "var(--green-dark)", marginBottom: 12 }}>
            ${activeRate.ratePerKg}<span style={{ fontSize: 14, fontWeight: 400, color: "var(--text-muted)" }}>/kg</span>
          </div>

          {/* Calculator */}
          <div style={{ borderTop: "0.5px solid var(--border)", paddingTop: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text-muted)", marginBottom: 8 }}>Cost calculator</div>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <div style={{ position: "relative", flex: 1 }}>
                <input type="number" step="0.1" min="0" value={weight} onChange={e => setWeight(e.target.value)} placeholder="Enter weight in lbs" style={{ paddingRight: 36 }} />
                <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontSize: 12, color: "var(--text-muted)" }}>lbs</span>
              </div>
              {cost && (
                <div style={{ background: "var(--green-light)", borderRadius: "var(--radius)", padding: "9px 16px", fontWeight: 700, fontSize: 15, color: "var(--green-dark)", whiteSpace: "nowrap" }}>
                  ≈ ${cost}
                </div>
              )}
            </div>
            {cost && (
              <div style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 6 }}>
                {weight} lbs = {(parseFloat(weight) * 0.453592).toFixed(2)} kg × ${activeRate.ratePerKg}/kg = ${cost}
              </div>
            )}
          </div>
        </>
      ) : (
        <div style={{ fontSize: 13, color: "var(--text-muted)" }}>No rate set for {UNITS[selUnit]?.label} in this warehouse.</div>
      )}
    </div>
  );
}
